export default __webpack_public_path__ + "static/media/titleBackground.ee70f5b1.svg";